import { PaymentMethodType } from '@/modules/employee/employee.types';
import { ClaimOffsetLogic, WaitingForFundsContinuePayment } from '@/modules/employer/types';
import { storeCreator } from '@/utils/store/store.utils';

const INIT_STATE = {};

export type PaymentEmployeeFees = { [key: string]: string };
interface ReimbursementState {
  isReimbursementAllowed?: boolean;
  isBillPayAllowed?: boolean;
  isClaimOffsetsAllowed?: boolean;
  claimOffsetLogic?: ClaimOffsetLogic;
  allowedPaymentMethods?: PaymentMethodType[];
  minimumPaymentReimbursementAmount?: number;
  waitingForFundsContinuePayment?: WaitingForFundsContinuePayment;
  waitingForFundsExpiration?: string;
}
interface State {
  state: ReimbursementState;
  paymentEmployeeFees: PaymentEmployeeFees;
  setReimbursement: (value: ReimbursementState) => void;
  setPaymentEmployeeFee: (value: string, paymentMethodType: PaymentMethodType) => void;
}

const useStore = storeCreator<State>((set) => ({
  state: INIT_STATE,
  paymentEmployeeFees: {},
  setReimbursement: (value: ReimbursementState) => set(() => ({
    state: value,
  })),
  setPaymentEmployeeFee: (value: string, paymentMethodType: PaymentMethodType) => set((store) => ({
    ...store,
    paymentEmployeeFees: {
      ...store.paymentEmployeeFees,
      [paymentMethodType]: value,
    } as PaymentEmployeeFees,
  })),
}));
const useReimbursementStore = () => ({ ...useStore() });

export default useReimbursementStore;
